import React from "react";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((_theme) => ({
    popupElement: {
        width: "100%",
        marginTop: 20,
    },
}));

export default function CallNo(props) {
    const { t } = useTranslation("translation");
    const classes = useStyles();
    return (
        <TextField
            id="bl_table_TextField_8"
            onChange={props.FilterOrderId}
            defaultValue=""
            value={!props.selectedMaintenanceOrderId || props.selectedMaintenanceOrderId === "null" ? "" : props.selectedMaintenanceOrderId}
            label={t("CallNumber")}
            variant="outlined"
            size={props.size ?? "normal"}
            className={classes.popupElement}
            type="number"
            onInput={(e) => {
                e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 12);
            }}
        />
    );
}
